import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ThemeComponent from "./styles/theme/ThemeComponent";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { LayoutContextProvider } from "./contexts/LayoutContext/LayoutContext";
import { UserContextProvider } from "./contexts/UserContext/UserContext";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { observeHeadChanges } from "./styleLayerWrapper";
import { CSUIThemeProvider } from "@coolset/cs-ui";

const customCache = createCache({
  container: document.head || undefined,
  key: "mui",
});
observeHeadChanges();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Router>
    <QueryClientProvider client={queryClient}>
      <CacheProvider value={customCache}>
        <ThemeComponent>
          <UserContextProvider>
            <LayoutContextProvider>
              <CSUIThemeProvider>
                <App />
              </CSUIThemeProvider>
            </LayoutContextProvider>
          </UserContextProvider>
        </ThemeComponent>
      </CacheProvider>
    </QueryClientProvider>
  </Router>
);
